<template>
	<div>
		<div class="detailPage">
			<div class='load' v-show='showLoading'>
				<loading />
			</div>
			<template v-if='!showLoading'>
				<Row class='product'>
					<Col :lg='10' style="position: relative;">
						<Carousel v-if='imageList[0]' v-model="noticeIndex" :autoplay-speed='5000' :arrow="'hover'">
							<CarouselItem v-for="item in imageList" :key="item.src">
								<div class='carousellayou' @click="autoNo(item)">
									<template v-if='item.type=="video"'>
										<template v-if='item.src.indexOf("dohwg.cn") != -1' >
											<div class="wrap">
												<Video 
													class='video' 
													:src='item.src'
													:pic='item.icon'
													@onPlayEnded='autoplay = true'
													@onPause='autoplay = true'
													@onPlaying='autoplay = false'
												/>
											</div>
											
										</template>
										<template v-else>
											<div class='videoMask'>
												<img src='@/assets/order/bplay.png'  >
											</div>
											<img class='product_img' src="@/assets/defaultImg.png" v-real-img="item.icon"  />
										</template>

									</template>
									<template v-else>
										<img  class='product_img' src="@/assets/defaultImg.png"  v-real-img="item.icon"  />
									</template>
								</div>
							</CarouselItem>
						</Carousel>
					</Col>
					<Col :lg='14' class='right'>
					<p class="pro-name">{{product.name}}</p>
					<p class="sku">SKU：{{product.sku}}</p>
					<section class="info" v-if='product.specproducts&&product.specproducts[0]'>
						<span class="info-pv">点数(Points):{{product.specproducts[0].pv}}</span>
						<span class="info-ge">{{product.specproducts[0].specs[0].name}}(Specifications)：{{product.specproducts[0].specs[0].value}}</span>
						<span class="info-pt" v-if="product.specproducts[0].pt>0">PT:{{product.specproducts[0].pt}}</span>
					</section>
					<section class="activityflag" v-if='showActivity(product)'>
						<span v-if='product.is_hot == 1' class="hot">热销<b>(Hot)</b></span>
						<span v-if='product.is_new == 1' class="hot">新品<b>(New)</b></span>
						<span v-if='product.is_promotion == 1' class="hot">促销<b>(Promotion)</b></span>
					</section>
					<div class='price'>
						<template v-if='product.specproducts&&product.specproducts[0]'>
							¥{{isPVOriginalPrice? product.specproducts[0].original_price : product.specproducts[0].price}}
						</template>
					</div>
					<div class='short-description' v-if='isdescription' v-html="description"></div>

					<!-- <p class="price" v-if='product.specproducts&&product.specproducts[0]'>¥{{$parent.isPVOriginalPrice? product.specproducts[0].original_price : product.specproducts[0].price}}</p> -->

					<div class="submit" v-if='false'>
						<Button type='primary' @click='back' size='large'>返回(back)</Button>
					</div>
					</Col>
				</Row>
				<p class="intro-title">产品详细说明(Description)</p>
				<Row class='detail'>
					<Col span="24">
					<Table class='no_mobile' style='margin-bottom: 10px;' :columns="columns1" border stripe :data="PriceList"></Table>
					<div class='xs-cells y_mobile' v-for='order in PriceList' style='margin-bottom: 10px;'>
						<Row class='xs-cells-item' style='margin-top: 0.2rem;'>
							<Col span='12'>产品编号(Product Sku)</Col>
							<Col span='12' style='text-align: center;'>{{order.sku}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>规格(Specification)</Col>
							<Col span='12' style='text-align: center;'>{{order.specification}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>零售价(Retail Price)</Col>
							<Col span='12' style='text-align: center;'>{{order.original_price}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>优惠顾客价(PC Price)</Col>
							<Col span='12' style='text-align: center;'>{{order.price}}</Col>
						</Row>
						<Row class='xs-cells-item'>
							<Col span='12'>点数(Points)</Col>
							<Col span='12' style='text-align: center;'>{{order.pv}}</Col>
						</Row>

					</div>
					</Col>
					<!-- <Col span='24' v-if='isdescription' v-html='description'>
					</Col> -->
				</Row>
				<div class="fordetail" v-html="detail_description"></div>
			</template>
		</div>
		<Modal v-model="showActivities" width="800" title="视频播放" :mask-closable="false">
			<div class='shipping-mian'>
				<iframe :src="showVideoUrl" frameborder="0" allowfullscreen="allowfullscreen" webkitallowfullscreen="true" mozallowfullscreen="true" :style="{height:350+'px',width:'100%'}"></iframe>
			</div>
			<div slot="footer">
				<!-- <Button size="large" @click="cancel">取消(cancel)</Button>
            <Button type="primary" size="large"  @click="confirm">确认(confirm)</Button> -->
			</div>
		</Modal>
	</div>
</template>

<script>
import loading from "@/components/order/loading";
import Video from '@/components/common/Video'
import {
	cartInfoMethods,
	userInfoOrderMethods
} from "@/components/common/mixin";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
	props:{
		product:{
			type:Object,
			default:{}
		},
		isPVOriginalPrice: {
			type:Boolean,
			default:false,
		},
	},
	data() {
		return {
			autoplay:true,
			scrollTop: 0,
			product: {},
			showLoading: true,

			description: "",
			detail_description: "",
			image_path: null,
			PriceList: [],
			imageList: [],
			relatedList: [],

			showActivities: false,
			noticeIndex: 0,
			showVideoUrl: null,
			offsetTop:0,
			columns1: [
				{
					key: "sku",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "产品编号"),
							h("div", null, "Product Sku")
						]);
					}
				},
				{
					key: "specification",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "规格"),
							h("div", null, "Specification")
						]);
					}
				},
				{
					key: "original_price",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "零售价"),
							h("div", null, "Retail Price")
						]);
					}
				},
				{
					key: "price",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "优惠顾客价"),
							h("div", null, "PC Price")
						]);
					}
				},
				{
					key: "pv",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "点数"),
							h("div", null, "Points")
						]);
					}
				}
			]
		};
	},
	created() {
		this.$nextTick(function() {
			this.initData();
		});
	},
	destroyed() {
		//window.removeEventListener("scroll", this.handleScroll);
	},

	mounted() {
	},
	watch: {
		showActivities:function(value){
			if(!value){
				this.showVideoUrl=null;
			}
		},
	},
	mixins: [userInfoOrderMethods, cartInfoMethods],
	components: {
		loading,
		Video
	},
	computed: {
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			forCustomer: state => state.order.forCustomer,
			cartInfo: state => state.order.cartInfo
		}),
		isdescription: function() {
			return this.description.length > 0;
		},
		isdetail_description: function() {
			return this.detail_description.length > 0;
		},
		goodsWidth(){
			if (document.body.clientWidth <= 768) {
				return 46 
			}
			return 18
		},
	},
	methods: {
		...mapActions([
			"getProductDetailAction",
			"getProductDetail1Action",
		]),
		showActivity(product) {
			return (
				product.is_hot == 1 ||
				product.is_new == 1 ||
				product.is_promotion == 1
			);
		},
		autoNo(item) {
			if (item.type == "video" && item.src.indexOf("dohwg.cn") == -1) {
				this.showActivities = true;
				this.showVideoUrl = item.src;
			}
		},
		handleScroll(scrollTop) {
			this.scrollTop = scrollTop;
		},
		back() {
			this.$router.go(-1);
		},
		async getheight(url){
			var img= await this.$loadImage(url);
			console.log('img---------',img)
			if(img){
				return img.height;
			}
		},
		async initData() {
			this.showLoading = true;
			let sku = this.product.sku;
			let response = await this.getProductDetailAction(sku);
			let relatedList = [];
			if (response) {
				this.detail_description = response.detail_description;
				this.description = response.description;
				this.image_path = response.image_path_big;
				let response1 = await this.getProductDetail1Action({
					sku,
					it: 1
				});
				if (response1) {
					let newmodel = [];
					response1.filter(item=>item.image_type == 1).forEach((item, index) => {
						if (item.url.indexOf("Video") == 0) {
						    //this.getheight().then((hegiht)=>{})
						    let src = item.url.split("=")[1]
						    if (src.indexOf('http') != 0) {
						    	src = `https://player.youku.com/embed/${src}?autoplay=false`
						    }
							newmodel.push({
								type: "video",
								icon: item.icon,
								src,
								first:false
							});
						} else {
							newmodel.push({
								type: "img",
								icon: item.icon,
								src: item.url,
								first:index==0?true:false
							});
						}
					});
					
					this.imageList = newmodel;
				
				}
				if (!this.imageList[0]) {
					this.imageList.push({
						type: "img",
						icon: response.image_path_big,
						src: response.image_path_big,
						first:true
					});
				}
			}
			console.log('this.product',this.product)
			this.PriceList=[];
			this.PriceList.push({
				sku: this.product.sku,
				specification:
					this.product.specproducts &&
					this.product.specproducts[0] &&
					this.product.specproducts[0].specification,
				original_price:
					this.product.specproducts &&
					this.product.specproducts[0] &&
					this.product.specproducts[0].original_price,
				price:
					this.product.specproducts &&
					this.product.specproducts[0] &&
					this.product.specproducts[0].price,
				pv:
					this.product.specproducts &&
					this.product.specproducts[0] &&
					this.product.specproducts[0].pv
			});
			this.showLoading = false;
		}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.root {
	background-color: white;
	z-index: 88;
}
.root2 {
	display: flex;
	position: absolute;
	flex-direction: column;
	width: 100%;
	//height: 100%;
	//min-height: 500px;
	z-index: 88;
	//background-color: white;
	background-color: white;
	position: absolute;
}
.load {
	height: 300px;
	position: relative;
}
.detailPage {
	// width: 1104px;
	// margin: auto;
	height:70vh;
	overflow: scroll;
	margin: 40px auto;
	margin-top: 0;
}
.breadcrumbPage {
	background-color: #f5f5f5;
	line-height: 30px;
	overflow: hidden;
}
.root2 .breadcrumb {
	margin: auto;
}
.breadcrumb {
	width: 78.03vw;
	@include fontSize($font-size-20);
	background-color: #f5f5f5;
	padding: 0.1rem;
	color: $theme-color;
}
.product {
	width: 78.03vw;
	//max-width: 1090px;
	margin: auto;
	margin-top: 25px;
}
.show_nostock {
	font-weight: bold;
	@include fontSize($font-size-15);
	display: inline-block;
	line-height: 24px;
	padding: 5px 8px;
	background-color: #ccc;
	color: white;
	// border-radius: 5px;
	margin-top: 10px;
}
.img-responsive {
	display: block;
	max-width: 100%;
	height: auto;
}

.short-description {
	margin-bottom: 20px;
	clear: both;
	color: #868686;
	font-size: 16px;
	margin-top: 5px;
}
.stepper {
	margin-top: 20px;
}
.right {
	padding-left: 0.4rem;
	margin-bottom: 1rem;
}
.pro-name {
	font-size: 32px;
	color: $theme-color;
}
.sku {
	@include fontSize($font-size-14);
	margin-top: 10px;
	padding-left: 2px;
}
.info {
	padding-left: 2px;
	margin-top: 10px;
	span {
		// color:rgba(158, 158, 158, 0.91);
	}
	.info-ge {
		margin-left: 10px;
	}
	.info-pt {
		margin-left: 10px;
	}
}
.price {
	font-size: 36px;
	color: $theme-color;
}
.activityflag {
	padding-top: 18px;
	span {
		display: inline-block;
		// float: right;
		// width: 36px;
		// height: 18px;
		// line-height: 18px;
		margin-left: 4px;
		@include fontSize($font-size-14);
		color: #fff;
		text-align: center;
		padding: 2px 4px;
	}
	span:first-child {
		margin-left: 0;
	}
	.hot {
		background-color: $theme-color;
	}
}
.buy {
	margin-top: 0.5rem;
	background-color: $theme-color;
	border-color: $theme-color;
}
.intro-title {
	line-height: 3;
	//border-bottom: 1px solid rgba(158, 158, 158, 0.5);
	@include fontSize($font-size-16);
	color: $theme-color;
}
.detail {
	@include fontSize($font-size-16);
	margin: auto;
	margin-top: 10px;
}
.submit {
	margin-top: 10px;
}
.breadcrumb {
	margin: 0.1rem 0;
	@include fontSize($font-size-16);
	background-color: #f5f5f5;
	padding: 0.1rem;
	color: $theme-color;
}
.y_mobile {
	display: none;
}
.detail-link {
	font-weight: 500;
	color: $theme-color;
}
.fordetail {
	width: 47vw;
	margin: auto;
	
}


.carousellayou {
	position: relative;
	//height: 00px;
	width: 85%;
	margin: auto;
	.video {
		position:absolute;
		width: 100%;
		height:100%;
	}
	.wrap {
		width:100%;
	    height:0;
	    padding-bottom:100%;
      	background-color: #0f8bcb;
      	position: relative;
	}
	.product_img {
		width: 100%;
	}
	overflow: hidden;
}
.videoMask {
	cursor: pointer;
	//background-color:#2626264d;
	//  background-color:black;
	//  opacity: 0.5;
	//height: 100%;
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
	text-align: center;
	img {
		width: 60px;
		//padding-top: 30%;
		position: absolute;
		top: 40%;
		left: 45%;
		margin: auto auto;
	}
	// position:absolute;
}
.m-result {
	overflow: hidden;
	ul {
		list-style: none;
	}
}
.maskView{
	width: 100%;
	position: absolute;
	//bottom: 20px;
	background: #ccc;
	text-align: center;
	color: white;
	@include fontSize($font-size-15);
	padding:5px 0;
	font-weight: 800;
}

@media (max-width: 768px){
	.container {
		width: inherit;
		margin-top: 70px;
		width: 95%;
	}
	.no_mobile {
		display: none;
	}
	.y_mobile {
		display: block;
	}
	.right {
		padding: 0;
	}
	.pro-name {
		font-size: 0.8rem;
	}

.detailPage{
	margin: 20px auto;
}
.product{
	width: 100%;

}
div.carousellayou{
	width: 100%;
}
div.breadcrumb{
	font-size: 0.6rem;
	width: 95.00vw;
}
.sku{
	font-size: 0.7rem;
}
.info{
	font-size: 0.7rem;
}
.price{
	font-size: 1.5rem;
}
.short-description{
	font-size: 0.6rem;
	line-height: 20px;
}
.intro-title{
	font-size: 0.8rem;
}
.detail{
	margin-top: 0px;
	font-size: 0.6rem;
    line-height: 30px;
    text-align: center;
}
.fordetail{
	width: 100%;
	overflow: hidden;
}
}

</style>